export default {
	countdown: 10,
	isOpen: false,
	onFinished: () => null,
};
